import { httpRequest } from '@shared/api/httpRequests'
import { SYSTEM_DATA_API } from '@shared/api/systemData.api'
import { SITE_SCRIPTS } from '@shared/constants/siteContent'
import { urlSubst } from '@shared/utils/url'

const url = urlSubst(SYSTEM_DATA_API.GET_SITE_CONTENT, { name: SITE_SCRIPTS })

/**
 * Fetch site-level <head> scripts and register them with the given unhead
 * instance. Must be passed the head instance directly (rather than calling
 * `useHead`) because this runs outside of any Vue component setup() context.
 */
export const setupSiteScripts = async (head) => {
  const scripts = await httpRequest({ url })

  if (scripts?.head?.length && head?.push) {
    head.push(
      {
        script: scripts.head,
      },
      { tagPosition: 'head' },
    )
  }
}
